










































































































































import { Vue, Component, Prop } from "vue-property-decorator";
import { CreateElement } from "vue";
import _ from "@/boot/lodash";

// Enums/Data
import { DataModules } from "@/store/modules/data";
import { WebhookStatuses } from "@/data/enums/webhooks";

// Types
import { IWebhookEvent } from "@/models/webhooks";
import { ITemplateCategory } from "@/models/templates";

@Component({
  components: {
    "event-message": () =>
      import("@/components/app/global/timelineComponent/eventMessage.vue"),
    "webhook-event-provider": () =>
      import(
        "@/components/app/admin/settings/webhooks/webhookEventProvider.vue"
      )
  }
})
export default class ViewWebhookEventModal extends Vue {
  // Props

  @Prop({ default: null })
  public webhookEventId!: IWebhookEvent["id"];

  @Prop({ default: [] })
  public categories!: ITemplateCategory[];

  // Methods

  public rawEventCell(sourceEvent) {
    return {
      render: (h: CreateElement) =>
        h(
          "td",
          {
            class: "is-compact is-paddingless has-cursor-pointer",
            on: {
              click: (event: Event) => {
                event.preventDefault();
                event.stopPropagation();
                this.openLogModal(sourceEvent);
              }
            }
          },
          [
            h(
              "b-tooltip",
              {
                props: {
                  label: this.$t("_.view_raw_event_data"),
                  position: "is-left",
                  type: "is-dark"
                }
              },
              [h("span", { class: "u-raw-data-icon" })]
            )
          ]
        )
    };
  }

  public openLogModal(data) {
    this.$store.dispatch("ui/open/slideModal", {
      config: {
        component: () =>
          import(
            "@/components/app/global/timelineComponent/timelineLogModal.vue"
          ),
        props: {
          title: this.$t("_.details"),
          data,
          deep: 1
        }
      }
    });
  }

  public categoryName(hookId) {
    return _.get(
      _.find(this.categories, category =>
        _.some(category.hooks || [], ["id", hookId])
      ),
      "name",
      "-"
    );
  }

  public hasFailed(status) {
    return status === WebhookStatuses.FAILED;
  }

  public mappedStatus(status) {
    return this.$store.getters[
      `data/${DataModules.WEBHOOKS_EVENTS}/getEventMappedStatus`
    ](status);
  }
}
